import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getDashboardPath, getLoginPath } from "../../../utils/authRedirect";
import { hasAccessToken } from "../../../utils/authStorage";
import { normalizeRole } from "../../../utils/roles";
import Preloader from "../../common/Preloader";
import { ClientSplashStatic } from "../../Clinic/PatientPortal/ClientSplash";
import { AdminSplashStatic } from "../../Clinic/AdminPortal/AdminSplash";

const WithRole = ({ children, roles, loginPath }) => {
  const navigate = useNavigate();
  const initialized = useSelector((state) => state.init.initialized);
  const { isAuth, role } = useSelector((state) => ({
    isAuth: state.auth.isAuth,
    role: state.auth.role,
  }));

  const expectedRole = roles?.[0];
  const redirectLogin = loginPath || getLoginPath(expectedRole);
  const waitingSession = initialized && !isAuth && hasAccessToken();
  const isClientPortal = roles?.includes("client");
  const isAdminPortal = roles?.some((r) => r === "admin" || r === "owner");
  const loader = isClientPortal ? (
    <ClientSplashStatic />
  ) : isAdminPortal ? (
    <AdminSplashStatic />
  ) : (
    <Preloader />
  );

  useEffect(() => {
    if (!initialized || waitingSession) return;
    if (!isAuth) {
      navigate(redirectLogin, { replace: true });
      return;
    }
    const r = normalizeRole(role);
    const allowed = roles?.map(normalizeRole);
    if (allowed?.length && r && !allowed.includes(r)) {
      navigate(getDashboardPath(r), { replace: true });
    }
  }, [
    initialized,
    waitingSession,
    isAuth,
    role,
    roles,
    navigate,
    redirectLogin,
  ]);

  if (!initialized || waitingSession) {
    return loader;
  }

  const r = normalizeRole(role);
  const allowed = roles?.map(normalizeRole);
  if (!isAuth || (allowed?.length && r && !allowed.includes(r))) {
    return loader;
  }

  return <>{children}</>;
};

export default WithRole;
